import * as React from 'react';
import { createContext } from 'react';

import type { CampaignModulesData } from 'bundles/campaigns/types/CampaignModulesData';
import applyContentfulOverrides from 'bundles/campaigns/utils/applyContentfulOverrides';

export type { CampaignModulesData };

type CampaignModulesDataContextType = {
  loading?: boolean;
  campaignData?: CampaignModulesData;
};

const CampaignModulesDataContext = createContext<CampaignModulesDataContextType>({});

export const useCampaignModulesData = (): CampaignModulesDataContextType => {
  const { loading, campaignData } = React.useContext(CampaignModulesDataContext);
  return React.useMemo(
    () => ({ loading, campaignData: applyContentfulOverrides(campaignData) }),
    [loading, campaignData]
  );
};

export default CampaignModulesDataContext;
